"use client";

import React, { createContext, useContext, useState } from "react";

const PostModalContext = createContext(null);

export const PostModalProvider = ({ children }) => {
  const [selectedPostId, setSelectedPostId] = useState(null);
  const [highlightCommentId, setHighlightCommentId] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const openPostModal = (postId, commentId = null) => {
    if (postId) {
      setSelectedPostId(postId);
      setHighlightCommentId(commentId);
      setIsOpen(true);
    }
  };

  const closePostModal = () => {
    setIsOpen(false);
    // Clear post and comment IDs after a short delay to allow modal close animation
    setTimeout(() => {
      setSelectedPostId(null);
      setHighlightCommentId(null);
    }, 300);
  };

  return (
    <PostModalContext.Provider
      value={{
        selectedPostId,
        highlightCommentId,
        isOpen,
        openPostModal,
        closePostModal,
      }}
    >
      {children}
    </PostModalContext.Provider>
  );
};

export const usePostModal = () => {
  const context = useContext(PostModalContext);
  if (!context) {
    throw new Error("usePostModal must be used within PostModalProvider");
  }
  return context;
};

